import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { environment } from "environments/environment";

import { PagedResponse } from "@app/shared/models/response.model";
import { InternalPosition } from "@models/internal-position.model";

@Injectable()
export class InternalPositionService {

    static readonly API_INTERNAL_POSITION_BASE_PATH = `${environment.baseURL}/api/internalPositions`;

    constructor(private http: HttpClient) {
    }

    getAllInternalPositions() {
        return this.http.get<PagedResponse<InternalPosition>>(`${InternalPositionService.API_INTERNAL_POSITION_BASE_PATH}`);
    }
}
